/** Confirmed business rule: a standard container holds 60 cubic metres. */
export const CONTAINER_CAPACITY_CBM = 60;

/** Legacy RFQ storage keeps intermediate money values at seven decimal places. */
export const RFQ_CALCULATION_DECIMAL_PLACES = 7;
